import React, { Component } from 'react';
import Thumbnail from 'components/common/Thumbnail';
import Tiltable from 'components/common/Tiltable';

class Rows extends Component {
	render() {
		const thumbnails = (this.props.items) ? this.props.items.map( item => 
			<RowItem key={item.slug} {...item} /> 
		) : null;
		return <div className="Rows">{thumbnails}</div>
	}
}

class RowItem extends Component {
	render() {
		const ratio = this.props.width / this.props.height;
		const innerStyle = {
			width: (ratio >= 1)? '100%' : ratio*100+'%'
		}
		return (
			<div ref={this.el} className="RowItem">
				<div className="RowItem-inner" style={innerStyle}>
					<TiltableThumb {...this.props} />
				</div>
			</div>
		)
	}
}

const TiltableThumb = Tiltable( Thumbnail );

export default Rows;


// WEBPACK FOOTER //
// ./src/components/Pages/Curated/Rows.jsx